import Price from '~/utils/Price';

import { CeilingPrice } from './CeilingPrice';
import { Error, ErrorCode } from './Error';
import ReferencedProduct from './ReferencedProduct';

export default class FinalCalculation {
	biosimilarReferencePrice: Price | null;

	ceilingPrice: CeilingPrice | null;

	emptyResultReason: Error[];

	genericReferencePrice: Price | null;

	referencedProduct: ReferencedProduct | null;

	constructor(
		biosimilarReferencePrice: Price | null,
		ceilingPrice: CeilingPrice | null,
		emptyResultReason: Error[],
		genericReferencePrice: Price | null,
		referencedProduct: ReferencedProduct | null
	) {
		this.biosimilarReferencePrice = biosimilarReferencePrice;
		this.ceilingPrice = ceilingPrice;
		this.emptyResultReason = emptyResultReason;
		this.genericReferencePrice = genericReferencePrice;
		this.referencedProduct = referencedProduct;
	}

	hasMissingProductSettings(): boolean {
		return (
			this.emptyResultReason.find((error) => error.code === ErrorCode.requiredProductSettingsMissing) !== undefined
		);
	}

	requiresMinOneReferenceProductErrorCode(): boolean {
		return (
			this.emptyResultReason.find((error) => error.code === ErrorCode.requiresMinOneReferenceProduct) !== undefined
		);
	}

	findMaxOneReferenceProductError(): Error | null {
		return this.emptyResultReason.find((error) => error.code === ErrorCode.requiresMaxOneReferenceProduct) ?? null;
	}

	isMissingReferenceSettings(): boolean {
		return this.emptyResultReason.find((error) => error.code === ErrorCode.requiresReferenceSettings) !== undefined;
	}

	isIllegalProductPriceTypeSelected(): boolean {
		return this.emptyResultReason.find((error) => error.code === ErrorCode.illegalPriceTypeSelected) !== undefined;
	}
}
